//vendors
import React from 'react';
import classNames from "classnames";

//styles
import styles from './radio_button_group.module.scss';


type RadioButtonProps = {
	disabled?: boolean,
	value: string | number,
	label: string | JSX.Element,
	name: string,
	isChecked: boolean,
	onChange: (e:any) => void,
	className?: string,
	info?: string
};

export const RadioButton = (props: RadioButtonProps) => {
	return (
		<div className={classNames(props.className, styles.radioItem, {[styles.isDisabled]: props.disabled})} key={props.value}>
			<label htmlFor={props.value.toString()}>
				<input
					type="radio"
					id={props.value.toString()}
					name={props.name}
					value={props.value}
					onChange={props.onChange}
					checked={props.isChecked}
					disabled={props.disabled}
				/>
				<span>{props.label} <span className={styles.info}>{props.info}</span></span>
			</label>
		</div>
	)
}

RadioButton.defaultProps = {
	disabled: false
};
